var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _ellipse, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _ellipse2, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _ellipse3, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _ellipse4, _g146, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgElements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 851,
    viewBox: "0 0 1440 851",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 80.56,
    cy: 41.0249,
    rx: 1.56,
    ry: 1.023,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 145.975,
    cy: 38.0182,
    rx: 0.974998,
    ry: 0.639374,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 421.305,
    cy: 36.2673,
    rx: 1.30499,
    ry: 0.855778,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 576.005,
    cy: 47.2186,
    rx: 1.005,
    ry: 0.659048,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 699.545,
    cy: 43.6381,
    rx: 1.54501,
    ry: 1.01316,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 740.755,
    cy: 7.70856,
    rx: 1.755,
    ry: 1.15087,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 993.425,
    cy: 21.9191,
    rx: 1.42499,
    ry: 0.93447,
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1018.53,
    cy: 52.8091,
    rx: 1.53,
    ry: 1.00333,
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1169.22,
    cy: 20.4698,
    rx: 1.21503,
    ry: 0.79676,
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1432.3,
    cy: 38.8904,
    rx: 1.30499,
    ry: 0.855778,
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1.305,
    cy: 106.741,
    rx: 1.305,
    ry: 0.855782,
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 279.365,
    cy: 106.124,
    rx: 1.36501,
    ry: 0.895123,
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 328.275,
    cy: 86.392,
    rx: 1.27499,
    ry: 0.836105,
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 506.725,
    cy: 108.327,
    rx: 1.72501,
    ry: 1.1312,
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 643.11,
    cy: 72.5127,
    rx: 1.10999,
    ry: 0.727905,
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 765.9,
    cy: 84.1788,
    rx: 0.899994,
    ry: 0.590195,
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 907.455,
    cy: 87.8216,
    rx: 1.45499,
    ry: 0.954144,
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1152.19,
    cy: 106.662,
    rx: 1.185,
    ry: 0.777088,
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1274.01,
    cy: 106.544,
    rx: 1.005,
    ry: 0.65905,
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1361.11,
    cy: 101.366,
    rx: 1.10999,
    ry: 0.727905,
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 70.9,
    cy: 162.521,
    rx: 0.900002,
    ry: 0.590195,
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 161.65,
    cy: 141.373,
    rx: 1.65,
    ry: 1.08202,
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 312.14,
    cy: 158.744,
    rx: 1.14,
    ry: 0.747581,
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 485.335,
    cy: 159.528,
    rx: 1.33501,
    ry: 0.87545,
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 625.47,
    cy: 118.303,
    rx: 1.47,
    ry: 0.963982,
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 806.095,
    cy: 129.205,
    rx: 1.095,
    ry: 0.718063,
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 995.095,
    cy: 138.386,
    rx: 1.095,
    ry: 0.718071,
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1112.77,
    cy: 152.6,
    rx: 1.77002,
    ry: 1.16071,
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1281.53,
    cy: 145.885,
    rx: 1.53003,
    ry: 1.00332,
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1406.95,
    cy: 139.599,
    rx: 0.945007,
    ry: 0.619705,
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 36.29,
    cy: 218.168,
    rx: 1.29,
    ry: 0.845947,
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 184.005,
    cy: 206.177,
    rx: 1.005,
    ry: 0.65905,
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 323.68,
    cy: 223.67,
    rx: 1.67999,
    ry: 1.10169,
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 535.185,
    cy: 224.001,
    rx: 1.185,
    ry: 0.777084,
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 682.38,
    cy: 182.815,
    rx: 1.38,
    ry: 0.904961,
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 761.485,
    cy: 194.032,
    rx: 1.48499,
    ry: 0.973816,
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 936.05,
    cy: 178.664,
    rx: 1.04999,
    ry: 0.68856,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1037.59,
    cy: 180.986,
    rx: 1.59003,
    ry: 1.04267,
    fill: "white"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1211.54,
    cy: 182.923,
    rx: 1.54498,
    ry: 1.01316,
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1298.03,
    cy: 174.064,
    rx: 1.03497,
    ry: 0.678719,
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 98.515,
    cy: 238.95,
    rx: 1.515,
    ry: 0.993492,
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 213.215,
    cy: 273.509,
    rx: 1.215,
    ry: 0.796768,
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 312.38,
    cy: 229.025,
    rx: 1.38,
    ry: 0.904968,
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 570.515,
    cy: 275.673,
    rx: 1.51501,
    ry: 0.9935,
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 576.93,
    cy: 232.009,
    rx: 0.929993,
    ry: 0.609863,
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 836.99,
    cy: 245.819,
    rx: 0.98999,
    ry: 0.649208,
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 872.59,
    cy: 249.492,
    rx: 1.59,
    ry: 1.04267,
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1145.59,
    cy: 260.64,
    rx: 1.59003,
    ry: 1.04268,
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1264.8,
    cy: 231.268,
    rx: 1.79999,
    ry: 1.18038,
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1313.19,
    cy: 236.111,
    rx: 1.185,
    ry: 0.777084,
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 98.945,
    cy: 335.936,
    rx: 0.945,
    ry: 0.619705,
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 246.29,
    cy: 286.98,
    rx: 1.29,
    ry: 0.845947,
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 392.44,
    cy: 325.113,
    rx: 1.44,
    ry: 0.944305,
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 510.665,
    cy: 297.062,
    rx: 1.66501,
    ry: 1.09186,
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 702.455,
    cy: 299.548,
    rx: 1.45499,
    ry: 0.954132,
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 838.44,
    cy: 334.293,
    rx: 1.44,
    ry: 0.944305,
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 959.005,
    cy: 334.008,
    rx: 1.005,
    ry: 0.659042,
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1043.09,
    cy: 326.854,
    rx: 1.09497,
    ry: 0.718063,
    fill: "white"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1159.14,
    cy: 330.818,
    rx: 1.14001,
    ry: 0.747574,
    fill: "white"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1432.16,
    cy: 311.81,
    rx: 1.15503,
    ry: 0.757401,
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 121.9,
    cy: 344.738,
    rx: 0.900002,
    ry: 0.590195,
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 184.155,
    cy: 371.136,
    rx: 1.155,
    ry: 0.757401,
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 395.35,
    cy: 380.444,
    rx: 1.35001,
    ry: 0.885284,
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 453.455,
    cy: 364.775,
    rx: 1.455,
    ry: 0.954147,
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 618.38,
    cy: 358.824,
    rx: 1.38,
    ry: 0.904968,
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 845.96,
    cy: 376.91,
    rx: 0.959991,
    ry: 0.629547,
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 951.2,
    cy: 384.281,
    rx: 1.20001,
    ry: 0.786911,
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1022.02,
    cy: 357.932,
    rx: 1.01999,
    ry: 0.668884,
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1191.5,
    cy: 379.887,
    rx: 1.5,
    ry: 0.983658,
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1318.9,
    cy: 351.951,
    rx: 0.900024,
    ry: 0.590195,
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 45.335,
    cy: 446.973,
    rx: 1.335,
    ry: 0.875443,
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 170.245,
    cy: 407.568,
    rx: 1.245,
    ry: 0.816437,
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 430.29,
    cy: 452.846,
    rx: 1.28999,
    ry: 0.845947,
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 496.185,
    cy: 409.496,
    rx: 1.185,
    ry: 0.777084,
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 680.335,
    cy: 421.398,
    rx: 1.33499,
    ry: 0.875458,
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 753.11,
    cy: 448.793,
    rx: 1.10999,
    ry: 0.727905,
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 962.53,
    cy: 447.101,
    rx: 1.53,
    ry: 1.00333,
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1061.99,
    cy: 421.172,
    rx: 0.98999,
    ry: 0.649216,
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1166.09,
    cy: 422.552,
    rx: 1.09497,
    ry: 0.718063,
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1357.24,
    cy: 435.766,
    rx: 1.245,
    ry: 0.816437,
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 81.35,
    cy: 476.799,
    rx: 1.35,
    ry: 0.885284,
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 227.785,
    cy: 495.445,
    rx: 1.785,
    ry: 1.17055,
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 386.2,
    cy: 459.65,
    rx: 1.2,
    ry: 0.786926,
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 567.29,
    cy: 457.086,
    rx: 1.29001,
    ry: 0.845947,
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 679.035,
    cy: 467.411,
    rx: 1.035,
    ry: 0.678726,
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 790.365,
    cy: 461.07,
    rx: 1.36499,
    ry: 0.895111,
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1005.04,
    cy: 464.132,
    rx: 1.035,
    ry: 0.678726,
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1125.96,
    cy: 485.068,
    rx: 0.960022,
    ry: 0.629547,
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1169.29,
    cy: 463.644,
    rx: 1.28998,
    ry: 0.845947,
    fill: "white"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1352.5,
    cy: 456.568,
    rx: 1.5,
    ry: 0.983658,
    fill: "white"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 102.62,
    cy: 555.318,
    rx: 1.62,
    ry: 1.06235,
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 225.14,
    cy: 545.167,
    rx: 1.14,
    ry: 0.747589,
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 418.41,
    cy: 515.834,
    rx: 1.41,
    ry: 0.924622,
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 514.02,
    cy: 566.073,
    rx: 1.01999,
    ry: 0.668884,
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 596.305,
    cy: 524.946,
    rx: 1.30499,
    ry: 0.855774,
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 830.065,
    cy: 541.183,
    rx: 1.065,
    ry: 0.698395,
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 977.44,
    cy: 517.166,
    rx: 1.44,
    ry: 0.944305,
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1013.55,
    cy: 549.367,
    rx: 1.54501,
    ry: 1.01315,
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1171.22,
    cy: 511.772,
    rx: 1.21503,
    ry: 0.796768,
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1356.24,
    cy: 560.974,
    rx: 1.245,
    ry: 0.816437,
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 26.095,
    cy: 571.674,
    rx: 1.095,
    ry: 0.718079,
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 199.425,
    cy: 589.596,
    rx: 1.425,
    ry: 0.934448,
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 391.365,
    cy: 583.655,
    rx: 1.36501,
    ry: 0.895111,
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 563.155,
    cy: 598.6,
    rx: 1.155,
    ry: 0.757416,
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 622.975,
    cy: 608.974,
    rx: 0.975006,
    ry: 0.639374,
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 817.23,
    cy: 616.355,
    rx: 1.23001,
    ry: 0.80661,
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 874.305,
    cy: 615.093,
    rx: 1.30499,
    ry: 0.855774,
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1113.8,
    cy: 589.842,
    rx: 1.79999,
    ry: 1.18039,
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1195.36,
    cy: 611.853,
    rx: 1.36499,
    ry: 0.895142,
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1355.2,
    cy: 576.989,
    rx: 1.20001,
    ry: 0.786926,
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 94.26,
    cy: 678.323,
    rx: 1.26,
    ry: 0.826263,
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 211.455,
    cy: 656.155,
    rx: 1.455,
    ry: 0.954163,
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 295.59,
    cy: 647.062,
    rx: 1.59,
    ry: 1.04269,
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 517.945,
    cy: 678.772,
    rx: 0.945007,
    ry: 0.61972,
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 698.515,
    cy: 627.34,
    rx: 1.51501,
    ry: 0.9935,
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 838.035,
    cy: 661.125,
    rx: 1.035,
    ry: 0.678711,
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 913.74,
    cy: 679.293,
    rx: 1.73999,
    ry: 1.14105,
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1046.38,
    cy: 629.875,
    rx: 1.38,
    ry: 0.904968,
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1227.16,
    cy: 636.941,
    rx: 1.15503,
    ry: 0.757416,
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1399.47,
    cy: 624.688,
    rx: 1.46997,
    ry: 0.963989,
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 5.065,
    cy: 697.518,
    rx: 1.065,
    ry: 0.698364,
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 269.185,
    cy: 689.728,
    rx: 1.185,
    ry: 0.7771,
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 328.365,
    cy: 718.044,
    rx: 1.36501,
    ry: 0.895111,
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 561.65,
    cy: 697.902,
    rx: 1.64999,
    ry: 1.082,
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 695.515,
    cy: 701.748,
    rx: 1.51501,
    ry: 0.9935,
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 749.335,
    cy: 721.303,
    rx: 1.33499,
    ry: 0.875458,
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 875.335,
    cy: 685.236,
    rx: 1.33499,
    ry: 0.875427,
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1108.3,
    cy: 700.955,
    rx: 1.30499,
    ry: 0.855774,
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1215.65,
    cy: 730.69,
    rx: 1.65002,
    ry: 1.08203,
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1414.06,
    cy: 706.699,
    rx: 1.065,
    ry: 0.698395,
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 110.335,
    cy: 774.071,
    rx: 1.335,
    ry: 0.875458,
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 193.68,
    cy: 774.297,
    rx: 1.68,
    ry: 1.10168,
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 350.005,
    cy: 773.198,
    rx: 1.005,
    ry: 0.659058,
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 442.155,
    cy: 743.131,
    rx: 1.155,
    ry: 0.757416,
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 594.32,
    cy: 759.634,
    rx: 1.32001,
    ry: 0.865631,
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 825.96,
    cy: 784.317,
    rx: 0.959991,
    ry: 0.629547,
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 962.975,
    cy: 768.588,
    rx: 0.975006,
    ry: 0.639374,
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1064.12,
    cy: 738.521,
    rx: 1.125,
    ry: 0.737732,
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1251.26,
    cy: 743.856,
    rx: 1.26001,
    ry: 0.826263,
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1348.06,
    cy: 773.238,
    rx: 1.065,
    ry: 0.698395,
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 37.005,
    cy: 841.704,
    rx: 1.005,
    ry: 0.659058,
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 264.095,
    cy: 827.992,
    rx: 1.095,
    ry: 0.718079,
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 381.56,
    cy: 813.87,
    rx: 1.56,
    ry: 1.02298,
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 525.44,
    cy: 832.809,
    rx: 1.44,
    ry: 0.944305,
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 668.785,
    cy: 795.656,
    rx: 1.785,
    ry: 1.17053,
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 811.59,
    cy: 849.957,
    rx: 1.59,
    ry: 1.04269,
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 870.9,
    cy: 833.111,
    rx: 0.899994,
    ry: 0.590179,
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1110.72,
    cy: 806.765,
    rx: 1.72498,
    ry: 1.1312,
    fill: "white"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1158.32,
    cy: 830.107,
    rx: 1.32001,
    ry: 0.865601,
    fill: "white"
  })), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1372.74,
    cy: 799.562,
    rx: 1.73999,
    ry: 1.14102,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.54 844.345L272.324 689.082C272.757 688.644 273 688.053 273 687.437C273 686.821 272.757 686.23 272.324 685.792C271.917 685.329 271.342 685.046 270.727 685.005C270.112 684.964 269.505 685.17 269.04 685.576L95.2004 834.909C94.5648 835.452 94.0439 836.116 93.6685 836.864C93.2931 837.611 93.0706 838.426 93.0143 839.261C92.9579 840.096 93.0688 840.934 93.3403 841.725C93.6118 842.516 94.0386 843.245 94.5954 843.869C95.1464 844.496 95.817 845.007 96.5679 845.372C97.3187 845.736 98.1346 845.947 98.9678 845.991C99.801 846.036 100.635 845.913 101.42 845.63C102.205 845.347 102.926 844.91 103.54 844.345Z",
    fill: "url(#paint0_linear_8391_26277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M166.457 784.916L270.165 689.819C270.3 689.686 270.406 689.527 270.479 689.353C270.552 689.178 270.59 688.991 270.59 688.801C270.59 688.612 270.552 688.425 270.479 688.25C270.406 688.075 270.3 687.917 270.165 687.784C269.899 687.525 269.542 687.38 269.171 687.38C268.8 687.38 268.443 687.525 268.177 687.784L161.531 779.159C161.14 779.491 160.819 779.898 160.588 780.356C160.356 780.813 160.218 781.313 160.181 781.825C160.145 782.338 160.212 782.852 160.377 783.338C160.542 783.824 160.802 784.272 161.142 784.656C161.824 785.377 162.757 785.807 163.748 785.855C164.738 785.904 165.709 785.567 166.457 784.916Z",
    fill: "url(#paint1_linear_8391_26277)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M455.378 349.838L573.527 240.865C573.83 240.558 574 240.143 574 239.71C574 239.278 573.83 238.863 573.527 238.556C573.242 238.231 572.84 238.032 572.409 238.004C571.978 237.975 571.554 238.119 571.228 238.404L449.54 343.215C449.095 343.596 448.731 344.063 448.468 344.588C448.205 345.112 448.049 345.684 448.01 346.27C447.971 346.856 448.048 347.444 448.238 347.999C448.428 348.555 448.727 349.066 449.117 349.504C449.502 349.945 449.972 350.303 450.498 350.559C451.023 350.815 451.594 350.963 452.177 350.994C452.761 351.025 453.344 350.939 453.894 350.74C454.443 350.542 454.948 350.235 455.378 349.838Z",
    fill: "url(#paint2_linear_8391_26277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M499.419 308.127L572.015 241.382C572.109 241.289 572.184 241.178 572.235 241.055C572.286 240.932 572.312 240.801 572.312 240.668C572.312 240.535 572.286 240.404 572.235 240.281C572.184 240.159 572.109 240.047 572.015 239.954C571.828 239.772 571.579 239.671 571.319 239.671C571.059 239.671 570.81 239.772 570.623 239.954L495.971 304.087C495.697 304.32 495.473 304.605 495.311 304.927C495.148 305.248 495.052 305.599 495.026 305.958C495.001 306.318 495.047 306.679 495.163 307.02C495.278 307.361 495.461 307.675 495.699 307.945C496.176 308.451 496.829 308.753 497.523 308.787C498.216 308.821 498.895 308.584 499.419 308.127Z",
    fill: "url(#paint3_linear_8391_26277)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.38 300.838L1264.53 191.865C1264.83 191.558 1265 191.143 1265 190.71C1265 190.278 1264.83 189.863 1264.53 189.556C1264.24 189.231 1263.84 189.032 1263.41 189.004C1262.98 188.975 1262.55 189.119 1262.23 189.404L1140.54 294.215C1140.1 294.596 1139.73 295.063 1139.47 295.588C1139.21 296.112 1139.05 296.684 1139.01 297.27C1138.97 297.856 1139.05 298.444 1139.24 298.999C1139.43 299.555 1139.73 300.066 1140.12 300.504C1140.5 300.945 1140.97 301.303 1141.5 301.559C1142.02 301.815 1142.59 301.963 1143.18 301.994C1143.76 302.025 1144.34 301.939 1144.89 301.74C1145.44 301.542 1145.95 301.235 1146.38 300.838Z",
    fill: "url(#paint4_linear_8391_26277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1190.42 259.127L1263.01 192.382C1263.11 192.289 1263.18 192.178 1263.23 192.055C1263.29 191.932 1263.31 191.801 1263.31 191.668C1263.31 191.535 1263.29 191.404 1263.23 191.281C1263.18 191.159 1263.11 191.047 1263.01 190.954C1262.83 190.772 1262.58 190.671 1262.32 190.671C1262.06 190.671 1261.81 190.772 1261.62 190.954L1186.97 255.087C1186.7 255.32 1186.47 255.605 1186.31 255.927C1186.15 256.248 1186.05 256.599 1186.03 256.958C1186 257.318 1186.05 257.679 1186.16 258.02C1186.28 258.361 1186.46 258.675 1186.7 258.945C1187.18 259.451 1187.83 259.753 1188.52 259.787C1189.22 259.821 1189.9 259.584 1190.42 259.127Z",
    fill: "url(#paint5_linear_8391_26277)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.38 211.838L1299.53 102.865C1299.83 102.558 1300 102.143 1300 101.71C1300 101.278 1299.83 100.863 1299.53 100.556C1299.24 100.231 1298.84 100.032 1298.41 100.004C1297.98 99.9751 1297.55 100.119 1297.23 100.404L1175.54 205.215C1175.1 205.596 1174.73 206.063 1174.47 206.588C1174.21 207.112 1174.05 207.684 1174.01 208.27C1173.97 208.856 1174.05 209.444 1174.24 209.999C1174.43 210.555 1174.73 211.066 1175.12 211.504C1175.5 211.945 1175.97 212.303 1176.5 212.559C1177.02 212.815 1177.59 212.963 1178.18 212.994C1178.76 213.025 1179.34 212.939 1179.89 212.74C1180.44 212.542 1180.95 212.235 1181.38 211.838Z",
    fill: "url(#paint6_linear_8391_26277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1225.42 170.127L1298.01 103.382C1298.11 103.289 1298.18 103.178 1298.23 103.055C1298.29 102.932 1298.31 102.801 1298.31 102.668C1298.31 102.535 1298.29 102.404 1298.23 102.281C1298.18 102.159 1298.11 102.047 1298.01 101.954C1297.83 101.772 1297.58 101.671 1297.32 101.671C1297.06 101.671 1296.81 101.772 1296.62 101.954L1221.97 166.087C1221.7 166.32 1221.47 166.605 1221.31 166.927C1221.15 167.248 1221.05 167.599 1221.03 167.958C1221 168.318 1221.05 168.679 1221.16 169.02C1221.28 169.361 1221.46 169.675 1221.7 169.945C1222.18 170.451 1222.83 170.753 1223.52 170.787C1224.22 170.821 1224.9 170.584 1225.42 170.127Z",
    fill: "url(#paint7_linear_8391_26277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8391_26277",
    x1: 272.9,
    y1: 685.607,
    x2: 94.808,
    y2: 843.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8391_26277",
    x1: -111673,
    y1: 74548.1,
    x2: -107949,
    y2: 74548.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8391_26277",
    x1: 573.93,
    y1: 238.426,
    x2: 448.974,
    y2: 348.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8391_26277",
    x1: -77788.5,
    y1: 52079.8,
    x2: -75181.4,
    y2: 52079.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8391_26277",
    x1: 1264.93,
    y1: 189.426,
    x2: 1139.97,
    y2: 299.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8391_26277",
    x1: -77097.5,
    y1: 52030.8,
    x2: -74490.4,
    y2: 52030.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8391_26277",
    x1: 1299.93,
    y1: 100.426,
    x2: 1174.97,
    y2: 210.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8391_26277",
    x1: -77062.5,
    y1: 51941.8,
    x2: -74455.4,
    y2: 51941.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgElements);
export default __webpack_public_path__ + "static/media/bg_elements.61dd62fce6b8f7fec90975ab1a796dee.svg";
export { ForwardRef as ReactComponent };